import React, { ComponentPropsWithoutRef } from 'react';
import { Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { Sample } from 'types/generated/graphql';
import { ClassifiersText } from 'components/ClassifiersText/ClassifiersText';

type BoxComponent = typeof Box;

interface NameSectionProps
    extends Omit<ComponentPropsWithoutRef<BoxComponent>, 'ref'> {
    sample: Sample;
    onClick?: (event: React.MouseEvent) => void;
    textStyle?: 'body-sm' | 'body' | 'lead';
}

const nameStyles = css({
    color: 'text.base',
    fontSize: { base: 'sm', lg: 'md' },
    fontWeight: 'bold',
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
});

export const NameSection: React.FC<NameSectionProps> = ({
    sample,
    onClick,
    textStyle,
    ...props
}) => {
    return (
        <Box display="flex" flexDirection="column" width="100%" {...props}>
            <Box onClick={onClick} className={nameStyles}>
                {sample.name}
            </Box>
            <ClassifiersText
                classifiers={sample.classifiers}
                isSearchEnabled={false}
                showExtra={false}
                packClassifierRule="force-visible"
            />
        </Box>
    );
};
